import OrdersPage from '@/pages/shared/OrdersPage'

export default function AdminOrders() {
  return <OrdersPage basePath="/admin" canEditShipment canOpenJobSheet showMineFilter={false} canProceed="all" />
}
